var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-10",staticStyle:{"display":"inline"}},[_c('span',{staticClass:"text-4xl text-black"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('span',{staticClass:"text-4xl text-bold text-red-500"},[_vm._v(" "+_vm._s(_vm.displayText.join(""))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }